module.exports = __webpack_public_path__ + "static/img/tianfangyuansucai2.c8ae0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tianfangyuansucai2.png
// module id = I4CU
// module chunks = 52